import PosthogService from '~/services/posthog/PosthogService';
import type { TInviteDropdownSource, TInviteProCategory } from './types';

export interface INewInviteClickedPayload {
  source: TInviteDropdownSource;
  proCategory: TInviteProCategory;
}

/**
 * Fires when the user clicks "New Invite" from the invite dropdown
 * Event: dental_portal:invite:new_invite_clicked
 */
export function fireNewInviteClicked(payload: INewInviteClickedPayload): void {
  PosthogService.getInstance().track('dental_portal:invite:new_invite_clicked', {
    source: payload.source,
    pro_category: payload.proCategory,
  });
}
